export default {"src":"/_next/static/media/icon-live-price.d9188c98.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};